// extracted by mini-css-extract-plugin
export var colFour = "styles-module--colFour--15efe";
export var colOne = "styles-module--colOne--42083";
export var colThree = "styles-module--colThree--0f986";
export var colTwo = "styles-module--colTwo--7e34b";
export var fourColTable = "styles-module--fourColTable--561aa";
export var fourColTableContainer = "styles-module--fourColTableContainer--7b4c2";
export var fourColTableDiv = "styles-module--fourColTableDiv--870f7";
export var title = "styles-module--title--465ac";